<div class="grid">
  <div class="col-12">
    <div class="card">
      <h5 translate>PRODUCTS.PRODUCTS</h5>
      <p-table #dt
               [value]="products"
               [lazy]="true"
               (onLazyLoad)="pageChanged($event)"
               selectionMode="single"
               [(selection)]="selectedProducts"
               dataKey="productId"
               [rowHover]="true"
               [rows]="filter.limit"
               [totalRecords]="(count$ | async) || 0"
               [showCurrentPageReport]="true"
               [rowsPerPageOptions]="[10,15,20,50,200]"
               [loading]="loading"
               [paginator]="true"
               currentPageReportTemplate="{{'TABLE.SHOWING' | translate}}"
               [filterDelay]="0"
               [globalFilterFields]="['name', 'code', 'color.name', 'type.name', 'category.name', 'subcategory.name']">
        <ng-template pTemplate="caption">
          <div class="flex flex-column sm:flex-row sm:align-items-center sm:justify-content-between gap-3 table-header">
            <span class="p-input-icon-left">
              <p-button icon="pi pi-plus" class="p-button-raised w-full"
                        *ngIf="this.keycloak.isUserInRole('ROLE_ADMINISTRATOR')"
                        (click)="openModal(null)"
                        [label]="'PRODUCTS.CREATE_PRODUCT' | translate"></p-button>
            </span>
            <p-iconfield class="table-search ml-auto" iconPosition="left">
                <p-inputicon>
                    <i class="pi pi-search"></i>
                </p-inputicon>
                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                           placeholder="{{'TABLE.GLOBAL_SEARCH' | translate}}" class="w-full"/>
            </p-iconfield>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="description">
              <div class="flex justify-content-between align-items-center" translate>
                PRODUCTS.NAME
                <p-sortIcon field="description"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="colorCc">
              <div class="flex justify-content-between align-items-center" translate>
                PRODUCTS.COLOR_CC
                <p-sortIcon field="colorCc"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="colorRal">
              <div class="flex justify-content-between align-items-center" translate>
                PRODUCTS.COLOR_RAL
                <p-sortIcon field="colorRal"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="colorNcs">
              <div class="flex justify-content-between align-items-center" translate>
                PRODUCTS.COLOR_NCS
                <p-sortIcon field="colorNcs"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="gloss">
              <div class="flex justify-content-between align-items-center" translate>
                PRODUCTS.GLOSS
                <p-sortIcon field="gloss"></p-sortIcon>
              </div>
            </th>
            <th style="width: 6.5rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
          <tr class="p-row">
            <td (click)="viewProduct(product.id)" class="cursor-pointer">
              {{product.description}}
            </td>
            <td>
              {{product.colorCc?.name}}
            </td>
            <td>
              {{product.colorRal?.code}}</td>
            <td>
              {{product.colorNcs?.name}}
            </td>
            <td>
              {{product.gloss?.name}}
            </td>
            <td>
              <button pButton type="button" class="p-button-label table-button mr-2" icon="pi pi-pencil"
                      (click)="openModal(product)"
                      *ngIf="this.keycloak.isUserInRole('ROLE_ADMINISTRATOR')"></button>
              <button pButton type="button" class="p-button-danger table-button" icon="pi pi-trash"
                      *ngIf="this.keycloak.isUserInRole('ROLE_ADMINISTRATOR')"
                      (click)="delete(product)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" translate>PRODUCTS.NO_PRODUCTS_FOUND</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


